import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgwWowService } from 'ngx-wow';
import { DataService, EmmiterService } from 'src/app/services/data.service';
import { HttpParams } from '@angular/common/http';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
// Multile Select Dropdown
import { DropdownMultiselectComponent } from 'src/app/shared/components/dropdown-multiselect/dropdown-multiselect.component';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { NavigationExtras, Router } from '@angular/router';
@Component({
    selector: 'app-admin-settings',
    templateUrl: './admin-settings.component.html',
    styleUrls: ['./admin-settings.component.css'],
})
export class AdminSettingsComponent implements OnInit {


    lstDocumentType: any = [];
    lstRole: any = [];
    lstProcess: any = [];
    lstFieldMapping: any = [];

    selectedDocumentType: string;
    selectedRoleId: string = "0";
    selectedProcessId: string = "0";
    advanceSearchColumnsToHide: any = [];


    constructor(
        private wowService: NgwWowService,
        private dataService: DataService,
        private commonService: CommonService,
        private modalService: NgbModal,
        private route: Router
    ) {
        wowService.init();
    }

    ngOnInit(): void {
        this.get_page_dropdown_data();
    }
    get_page_dropdown_data() {
        let params = new HttpParams();
        params = params.append('project_id', this.commonService.selectedProject);
        this.dataService.getData('settings/get_dropdown_data', params).subscribe((res) => {
            if (res != null && (res.error_message == null || res.error_message == "")) {
                if (res != null && res.status == true) {
                    res.data.Table.forEach((element) => {
                        this.lstDocumentType.push({
                            value: element.document_type_id.toString(),
                            text: element.document_type_name,
                        });
                    });

                    res.data.Table1.forEach((element) => {
                        this.lstRole.push({
                            value: element.role_id.toString(),
                            text: element.role_name,
                        });
                    });

                    res.data.Table2.forEach((element) => {
                        this.lstProcess.push({
                            value: element.process_id.toString(),
                            text: element.process_name,
                        });
                    });
                }
            }
            else {
                if (res.errorCode != 0 && res.errorCode == 4000) {
                    this.route.navigateByUrl('/unauthorized');
                    return;
                }
                if (res.errorCode != 0 && res.errorCode == 3000) {
                    this.commonService.showMessageBox("Internal error")
                }
            }
        },
            error => {
                if (error.includes("401")) {
                    this.route.navigateByUrl('/unauthorized');
                    return;
                }
            });
    }

    get_field_mapping_detail() {
        this.lstFieldMapping = [];
        let params = new HttpParams();
        params = params.append('project_id', this.commonService.selectedProject);
        params = params.append('document_type_id', this.selectedDocumentType);
        params = params.append('role_id', this.selectedRoleId);
        params = params.append('process_id', this.selectedProcessId);
        this.dataService.getData('settings/get_field_mapping_data', params).subscribe((res) => {
            if (res != null && (res.error_message == null || res.error_message == "")) {
                if (res != null && res.status == true) {
                    //this.lstFieldMapping = res.data;
                    res.data.forEach((element) => {
                        //field_mapping_detail_id
                        //field_mapping_id	
                        //field_name	
                        //is_readonly
                        //visiblerole_id
                        //editrole_id	
                        //mandatory_process_id	
                        //disabled_field_for_process_id	
                        //is_active

                        let default_disabled_field_for_process_id = (element.disabled_field_for_process_id != null ? element.disabled_field_for_process_id.split(',') : null);
                        let default_mandatory_process_id = (element.mandatory_process_id != null ? element.mandatory_process_id.split(',') : null);
                        let default_visiblerole_id = (element.visiblerole_id != null ? element.visiblerole_id.split(',') : null);
                        let default_editrole_id = (element.editrole_id != null ? element.editrole_id.split(',') : null);

                        //const difference_a1 = a1.filter(x => !a2.includes(x));
                        let default_editrole_Text = [];
                        let default_visiblerole_Text = [];
                        let default_mandatory_process_Text = [];
                        let default_disabled_field_for_process_Text = [];

                        if (default_visiblerole_id != null) {
                            let match_visible_role = this.lstRole.filter(x => default_visiblerole_id.includes(x.value));
                            if (match_visible_role != null && match_visible_role != undefined) {
                                if (match_visible_role.length > 0) {
                                    match_visible_role.forEach((item) => {
                                        default_visiblerole_Text.push(item.text);
                                    });
                                }
                            }
                        }

                        if (default_editrole_id != null) {
                            let match_role = this.lstRole.filter(x => default_editrole_id.includes(x.value));
                            if (match_role != null && match_role != undefined) {
                                if (match_role.length > 0) {
                                    match_role.forEach((item) => {
                                        default_editrole_Text.push(item.text);
                                    });
                                }
                            }
                        }

                        if (default_disabled_field_for_process_id != null) {
                            let match_disabled_process = this.lstProcess.filter(x => default_disabled_field_for_process_id.includes(x.value));
                            if (match_disabled_process != null && match_disabled_process != undefined) {
                                if (match_disabled_process.length > 0) {
                                    match_disabled_process.forEach((item) => {
                                        default_disabled_field_for_process_Text.push(item.text);
                                    });
                                }
                            }
                        }

                        if (default_mandatory_process_id != null) {
                            let match_mandatory_process = this.lstProcess.filter(x => default_mandatory_process_id.includes(x.value));
                            if (match_mandatory_process != null && match_mandatory_process != undefined) {
                                if (match_mandatory_process.length > 0) {
                                    match_mandatory_process.forEach((item) => {
                                        default_mandatory_process_Text.push(item.text);
                                    });
                                }
                            }
                        }

                        var rowData = {
                            slno: {
                                field_name: "field_order",
                                type: "string", value: element.field_order
                            },
                            field_mapping_detail_id: {
                                field_name: "field_mapping_detail_id",
                                type: "string", value: element.field_mapping_detail_id
                            },
                            field_mapping_id:
                            {
                                field_name: "field_mapping_id",
                                type: "string", value: element.field_mapping_id,

                            },
                            field_name:
                            {
                                field_name: "field_name",
                                type: "string", value: element.field_name
                            },
                            is_readonly:
                            {
                                field_name: "is_readonly",
                                type: "checkbox", value: element.is_readonly
                            },
                            visiblerole_id:
                            {
                                field_name: "visiblerole_id",
                                type: "multi-select-dropdown", value: default_visiblerole_id,
                                lstOption: this.lstRole, text: default_visiblerole_Text
                            },
                            editrole_id:
                            {
                                field_name: "editrole_id",
                                type: "multi-select-dropdown", value: default_editrole_id,
                                lstOption: this.lstRole, text: default_editrole_Text
                            },
                            mandatory_process_id:
                            {
                                field_name: "mandatory_process_id",
                                type: "multi-select-dropdown", value: default_mandatory_process_id,
                                lstOption: this.lstProcess, text: default_mandatory_process_Text
                            },
                            disabled_field_for_process_id:
                            {
                                field_name: "disabled_field_for_process_id",
                                type: "multi-select-dropdown", value: default_disabled_field_for_process_id,
                                lstOption: this.lstProcess, text: default_disabled_field_for_process_Text
                            },
                            is_active: {
                                field_name: "is_active",
                                type: "checkbox", value: element.is_active
                            },
                        };
                        this.lstFieldMapping.push(rowData);

                    });
                    this.advanceSearchColumnsToHide.push("field_mapping_detail_id");
                    this.advanceSearchColumnsToHide.push("field_mapping_id")
                }
            }
            else {
                if (res.errorCode != 0 && res.errorCode == 4000) {
                    this.route.navigateByUrl('/unauthorized');
                    return;
                }
                if (res.errorCode != 0 && res.errorCode == 3000) {
                    this.commonService.showMessageBox("Internal error")
                }
            }

        },
            error => {
                if (error.includes("401")) {
                    this.route.navigateByUrl('/unauthorized');
                    return;
                }
            }
        );
    }
    advanceSearchCellClick(event: any) {
    }
    Save_Field_mapping_Details() {
        let field_mapping_detail: any = [];
        this.lstFieldMapping.forEach((row) => {
            let item = {
                field_mapping_detail_id: row.field_mapping_detail_id.value,
                field_mapping_id: row.field_mapping_id.value,
                field_name: row.field_name.value,
                is_readonly: row.is_readonly.value == 1 ? true : false,
                visiblerole_id: (row.visiblerole_id.value != null ? row.visiblerole_id.value.toString() : null),
                editrole_id: (row.editrole_id.value != null ? row.editrole_id.value.toString() : null),
                mandatory_process_id: (row.mandatory_process_id.value != null ? row.mandatory_process_id.value.toString() : null),
                disabled_field_for_process_id: (row.disabled_field_for_process_id.value != null ? row.disabled_field_for_process_id.value.toString() : null),
                is_active: row.is_active.value == 1 ? true : false
            };
            field_mapping_detail.push(item);
        });


        let params = {
            field_mapping_detail: field_mapping_detail,
            is_apply_for_all_document_type_ids: false,
            project_id: Number(this.commonService.selectedProject),
            document_type_id: Number(this.selectedDocumentType)
        }
        this.dataService.postData('settings/save_field_mapping_detail', params).subscribe((res) => {
            if (res != null && (res.error_message == null || res.error_message == "")) {
                if (res != null && res.status == true) {
                    this.commonService.showMessageBox("Data saved successfully", "Message");
                }
                else {
                    this.commonService.showMessageBox("Ubable to save the changes", "Alert");
                }
            }
            else {
                if (res.errorCode != 0 && res.errorCode == 4000) {
                    this.route.navigateByUrl('/unauthorized');
                    return;
                }
                if (res.errorCode != 0 && res.errorCode == 3000) {
                    this.commonService.showMessageBox("Internal error")
                }
            }
        },
            error => {
                if (error.includes("401")) {
                    this.route.navigateByUrl('/unauthorized');
                    return;
                }
            });
    }

}